import { styled } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'
import { toKRW } from '~/app/utils/krNumberToString'

const Container = styled.div`
  ${Typography('body2').regular};
  background: ${({ theme }) => theme.color.gray50};
  padding: 0.8rem 1.6rem;
  margin-top: 1.2rem;
  border-radius: 0.4rem;
  text-align: center;
`

const BoldText = styled.div`
  ${Typography('body2').bold};
  margin-bottom: 0.4rem;
`

const Vip = styled.span`
  color: ${({ theme }) => theme.color.yagold};
`

type Props = {
  // 할인된 금액
  discountPrice: number
}

/**
 * 장바구니 > Vip 상품 구매 가능시 노출되는 1회성 혜택 안내
 */
const CartVipBenefitNotice = ({ discountPrice }: Props) => {
  return (
    <Container>
      <BoldText>
        <Vip>Gold Class</Vip>를 위한 특별한 혜택!
      </BoldText>
      <strong>{toKRW(discountPrice)}</strong> 더 할인받았어요
    </Container>
  )
}

export default CartVipBenefitNotice
